// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"1":"cb9d3111","141":"3d7e516d","144":"65be9074","235":"8ba03de1","425":"0e34116d","594":"62711a8d","855":"59fe0926","985":"2125c58f"}[chunkId] + ".css";
};